import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, catchError } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../model/api-response';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  readonly version = signal<string>('1.0.1');
  private versionSubject = new BehaviorSubject<string>('1.0.1');
  public version$ = this.versionSubject.asObservable();

  constructor(private http: HttpClient) {
    this.loadVersion();
  }

  private loadVersion(): void {
    const url = `${environment.apiUrl}/${environment.apiVersion}/version`;
    this.http
      .get<ApiResponse<{ version: string }>>(url)
      .pipe(
        tap((response) => {
          const ver = response.data?.version || response.version;
          if (ver) {
            this.version.set(ver);
            this.versionSubject.next(ver);
          }
        }),
        catchError(() => {
          return of(null);
        })
      )
      .subscribe();
  }

  /**
   * Ottiene la versione corrente
   */
  getVersion(): string {
    return this.version();
  }

  /**
   * Ottiene la versione come Observable per il binding nei template
   */
  getVersion$(): Observable<string> {
    return this.version$;
  }

  /**
   * Ricarica la versione dal server
   */
  refreshVersion(): Observable<string> {
    const url = `${environment.apiUrl}/${environment.apiVersion}/version`;
    return this.http.get<ApiResponse<{ version: string }>>(url).pipe(
      tap((response) => {
        const ver = response.data?.version || response.version;
        if (ver) {
          this.version.set(ver);
          this.versionSubject.next(ver);
        }
      }),
      map(() => this.version()),
      catchError(() => {
        return of(this.version());
      })
    );
  }
}


